import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { allowOnlyNumbersValidator, onTimeChange, phoneNumberLengthValidator, timeZone } from 'src/app/utils/utils.common';
import * as moment from 'moment';
import { MemberService } from 'src/app/services/core/member/member.service';
import { CreateTripComponent } from 'src/app/components/distributions/trip-intake/create-trip/create-trip.component';

@UntilDestroy()
@Component({
  selector: 'app-relation-leg-modal',
  templateUrl: './relation-leg-modal.component.html',
  styleUrls: ['./relation-leg-modal.component.css']
})
export class RelationLegModalComponent {
    @Output() closeModal = new EventEmitter<any>();
    @Input() tripId: any;
    trip: any;
    relationlegForm!: FormGroup;
    timeZone: any = timeZone;
    isWillCallPickup: boolean = false;
    status = true
    members: any;
    suffix:any;
    submitted = false;
  
    constructor(
      private fb: FormBuilder,
      private tripService: TripService,
      private sharedDataService: SharedDataService,
      private router: Router,
      private memberService: MemberService,
      private createTripComponent: CreateTripComponent,

    ) { }
  
  ngOnInit() {
    this.sharedDataService.getUser()
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data?.timeZone) {
          this.timeZone = data.timeZone;
        }
      });
    this.relationlegForm = this.createTripComponent.createForm();
    this.getTripDetails();
  }

  getTripDetails() {
    this.tripService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.trip = data;
        const memberId = this.trip?.member;
        if (memberId) {
          this.getMemberTripsById(memberId);
        }
        const pickupTime = moment(this.trip.destination.time).tz(this.timeZone).add(1, 'hour').toISOString();
        const dropoffTime = moment(this.trip.destination.time).tz(this.timeZone).add(2, 'hours').toISOString();
        this.relationlegForm.patchValue({
          ...data,
          pickup: {
            ...data.destination,
            time: pickupTime,
          },
          destination: {
            ...data.pickup,
            time: dropoffTime,
          },
        });
      }
    });
  }

  onPickupTimeChange() {
    const pickupControl = this.relationlegForm.get('pickup.time');
    onTimeChange(pickupControl);
    this.relationlegForm.get('destination.time')?.setValue(
      moment(pickupControl?.value).add(1, 'hour').toISOString()
    );
  }
  
  setWillCall(event: any, index: number) {
    if (index !== -1) return;

    const pickupTimeControl = this.relationlegForm.get('pickup.time');
    const destinationTimeControl = this.relationlegForm.get('destination.time');

    if (event.target.checked) {
      const existingPickup = pickupTimeControl?.value;
      if (existingPickup) {
        const pickupMoment = moment(existingPickup).tz(this.timeZone);
        pickupMoment.set('hour', 23).set('minute', 59);
        pickupTimeControl?.setValue(pickupMoment);
        const dropoffMoment = moment(existingPickup).tz(this.timeZone);
        dropoffMoment.set('hour', 23).set('minute', 59);
        destinationTimeControl?.setValue(dropoffMoment);
      }
    }
  }
  
  getMemberTripsById(memberId: any) {

    const pickupTime = this.trip?.pickup?.time;
    const startOfDay = moment(pickupTime).startOf('day').toISOString();
    const endOfDay = moment(pickupTime).endOf('day').toISOString();

    const QueryParams: any = {
      member: memberId,
      time: [startOfDay, endOfDay],
      limit: 9999,
    };

    this.memberService.getMembersTrips(QueryParams)
      .pipe(untilDestroyed(this))
      .subscribe((tripData: any) => {
        if (tripData && tripData.results) {
          const relatedTrips = tripData.results.filter((t: any) => t.reference === this.trip?.reference);
          const suffixOrder = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
          this.suffix = suffixOrder.find((letter) => !relatedTrips.some((t: any) => t.suffix === letter)) || 'B';
        }
      });
  }

  setPickupAddress(place: any) {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );

    this.relationlegForm.get('pickup.address')?.patchValue({
      name: place.formatted_address,
      coords: [place.geometry.location.lng(), place.geometry.location.lat()],
      city: city ? city.long_name : '',
      state: state ? state.long_name : '',
      zipCode: zipCode ? zipCode.long_name : '',
    });
  }

  onChangePickupAddress() {
    this.relationlegForm.get('pickup.address')?.patchValue({
      coords: [],
      city: '',
      state: '',
      zipCode: '',
    });
  }

  setDropoffAddress(place: any) {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );

    this.relationlegForm.get('destination.address')?.patchValue({
      name: place.formatted_address,
      coords: [place.geometry.location.lng(), place.geometry.location.lat()],
      city: city ? city.long_name : '',
      state: state ? state.long_name : '',
      zipCode: zipCode ? zipCode.long_name : '',
    });
  }

  onChangeDropoffAddress() {
    this.relationlegForm.get('destination.address')?.patchValue({
      coords: [],
      city: '',
      state: '',
      zipCode: '',
    });
  }

  createBLeg() {
    this.submitted = true;
    if (this.relationlegForm.invalid) return;

    const payload = this.relationlegForm.value;
    payload.suffix = this.suffix;
    payload.status = 'scheduled';
    if (payload.pickup.phoneNumber === '') {
      delete payload.pickup.phoneNumber;
    }
    if (payload.destination.phoneNumber === '') {
      delete payload.destination.phoneNumber;
    }

    this.tripService.createTrip(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: any) => {
          if (data) {
            sweetAlert('Success', 'Leg created successfully', 'success', 'OK');
            this.closeModal.emit(data);
            this.router.navigate(['trips'], { fragment: 'scheduled' });
          }
        },
        error: (err) => {
          sweetAlert('Error', err, 'error', 'Ok');
        }
      });
  }

  onCloseModal() {
    this.closeModal.emit();
  }

}
